<template>
  <v-icon>{{ creatorKbnIcon }}</v-icon>
</template>

<script>
export default {
  name: "CreatorKbnIcon",
  props: {
    creatorKbn: {
      mode: Number,
      required: true,
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    creatorKbnIcon() {
      if (this.creatorKbn == 1) {
        return "palette";
      } else if (this.creatorKbn == 2) {
        return "mic";
      } else if (this.creatorKbn == 3) {
        return "menu_book";
      } else {
        return "account_circle";
      }
    },
  },

  methods: {},
};
</script>

<style lang="scss" scoped></style>
